import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Persona } from '../Persona';
import { Txt } from '../UiKit/Txt';
import { Preloader, Preloader0 } from '../UiKit/kit';
import { PersonaYoni } from '../PersonaYoni';
import { Appearer } from '../UiKit/Appearer';

export function ListAvatars(props) {
  const context = { ...useContext(LangContext), ...useContext(StateContext), ...useContext(SocialContext) };
  const $ui = context.$ui;
  const {
    customHandler,
    customHandlerChosen,
    fullList = false,
    listId = '',
    array,
    exclude = [],
    chosen = [],
    actions,
    refetch,
    quantity = 0,
    createNew,
    customGridClass = '',
    celeb = false,
    fullSrceen = false,
    paginate,
    emptyMessage,
    scrollToTop = () => void (0),
    scrollTarget = null,
    onScrollTargetHandled = () => void (0),
    addMe = false,
    mode = 'hd',
    showIndex = false,
  } = { ...props };


  // const [searchParams] = useSearchParams();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState();
  const [loading, setLoading] = useState(false);
  const exhaustedAtRef = useRef(null);

  const sliceSize =
    paginate && (pageSize != null)
      ? pageSize
      : paginate && array?.length
        ? quantity > paginate
          ? paginate
          : quantity
        : null;

  const arr = useMemo(() => {
    if (!array) return undefined;
    if (!paginate) return array.filter(Boolean);
    if (sliceSize == null || sliceSize === 0) return array.filter(Boolean);
    return array.slice(page * sliceSize, (page + 1) * sliceSize).filter(Boolean);
  }, [array, paginate, page, sliceSize]);

  const inFlightSkipRef = useRef(null);
  const neededSkipsSigRef = useRef('');

  useEffect(() => {
    exhaustedAtRef.current = null;
    inFlightSkipRef.current = null;
    neededSkipsSigRef.current = '';
  }, [listId, paginate]);

  useEffect(() => {
    if (!paginate || !quantity) return;
    setPageSize(quantity > paginate ? paginate : quantity);
  }, [paginate, quantity]);

  useEffect(() => {
    if (!paginate || !pageSize || !quantity) return;
    const maxPage = Math.max(0, Math.ceil(quantity / pageSize) - 1);
    if (page > maxPage) setPage(maxPage);
  }, [paginate, pageSize, quantity, page]);

  const handlePageChange = (page) => {
    setPage(page);
    const y = scrollable.current ? scrollable.current.offsetTop : 0;
    scrollToTop(y - 120);
  }

  useEffect(() => {
    if (!quantity) return;
    if (!Array.isArray(array)) return;

    let loadMethod = null;
    switch (listId) {
      case 'avatars':
        loadMethod = context.x.loadAvatars;
        break;
      case 'followings':
        loadMethod = context.x.loadFollowings;
        break;
      case 'followers':
        loadMethod = context.x.loadFollowers;
        break;
      default:
        return;
    }
    if (!loadMethod) return;

    const meToken = context.me?.user?.token;
    const meAvatarToken = context.me?.avatar?.token;
    const leadingSticky = (
      listId === 'followings'
      && meToken
      && array[0]?.user?.token === meToken
    ) ? 1 : 0;

    const sourceList = listId === 'followings'
      ? context.followings
      : listId === 'followers'
        ? context.followers
        : null;

    const isServerItem = (item) => {
      if (!item || item._statsOnly) return false;
      if (listId === 'avatars') {
        return item.avatar?.token && item.avatar.token !== meAvatarToken;
      }
      return item.user?.token && item.user.token !== meToken;
    };

    const isDisplayReady = (item) => Boolean(item) && !item._statsOnly;

    const resolveApiIndex = (item, displayIndex) => {
      if (typeof item?._listIndex === 'number') return item._listIndex;
      const token = item?.user?.token;
      if (token && Array.isArray(sourceList)) {
        const found = sourceList.findIndex((one) => one?.user?.token === token);
        if (found >= 0) return found;
      }
      return Math.max(0, displayIndex - leadingSticky);
    };

    const loadedServerCount = array.filter(isServerItem).length;

    if (!paginate) {
      if (listId === 'followings' || listId === 'followers') {
        const hydrated = listId === 'followings'
          ? context.followingsHydrated
          : context.followersHydrated;
        if (hydrated || loadedServerCount + leadingSticky >= quantity) {
          setLoading(false);
          return;
        }
        setLoading(true);
        return;
      }
      if (loadedServerCount >= quantity) {
        setLoading(false);
        return;
      }
      const apiSkip = loadedServerCount;
      if (exhaustedAtRef.current != null && apiSkip >= exhaustedAtRef.current) {
        setLoading(false);
        return;
      }
      setLoading(true);
      let cancelled = false;
      loadMethod(apiSkip, quantity - apiSkip, (loaded = []) => {
        if (cancelled) return;
        if (!Array.isArray(loaded) || loaded.length === 0) {
          exhaustedAtRef.current = apiSkip;
        }
        setLoading(false);
      });
      return () => { cancelled = true; };
    }

    // Dense filtered lists (all slots are full personas). Stats-only rows still
    // need a page fetch so lazy results go through parseAvatar.
    const isDenseClientList = quantity > 0
      && array.length >= quantity
      && Array.from({ length: quantity }).every((_, i) => isDisplayReady(array[i]));
    if (isDenseClientList) {
      setLoading(false);
      return;
    }

    const windowSize = pageSize || paginate;
    const start = page * windowSize;
    if (start >= quantity) {
      setLoading(false);
      return;
    }

    const needed = Math.min(windowSize, quantity - start);
    const neededSkips = [];
    for (let i = start; i < start + needed; i++) {
      // Stats-only placeholders still need a real page fetch for bodygraphs.
      if (!isDisplayReady(array[i])) {
        const apiIndex = resolveApiIndex(array[i], i);
        const apiSkip = apiIndex - (apiIndex % paginate);
        if (!neededSkips.includes(apiSkip)) neededSkips.push(apiSkip);
      }
    }
    if (!neededSkips.length) {
      setLoading(false);
      return;
    }

    const skipsSig = neededSkips.join(',');
    if (skipsSig !== neededSkipsSigRef.current) {
      neededSkipsSigRef.current = skipsSig;
      // New filter window / new slim rows — allow retries past a stale exhausted marker.
      exhaustedAtRef.current = null;
    }

    const apiSkip = neededSkips.find((skip) => (
      exhaustedAtRef.current == null || skip < exhaustedAtRef.current
    ));
    if (apiSkip == null) {
      setLoading(false);
      return;
    }

    // Same page already fetching — don't restart on every slim-walk array update.
    if (inFlightSkipRef.current === apiSkip) {
      setLoading(true);
      return;
    }

    inFlightSkipRef.current = apiSkip;
    setLoading(true);
    loadMethod(apiSkip, paginate, (loaded = []) => {
      if (inFlightSkipRef.current === apiSkip) {
        inFlightSkipRef.current = null;
      }
      if (!Array.isArray(loaded) || loaded.length < paginate) {
        exhaustedAtRef.current = apiSkip + (loaded?.length || 0);
      }
      setLoading(false);
    });
  }, [
    page,
    paginate,
    pageSize,
    quantity,
    listId,
    array?.map((item, i) => (
      item?._statsOnly ? `s${item._listIndex ?? item?.user?.token ?? i}` : (item?.user?.token || item?.avatar?.token || i)
    )).join('|'),
    context.followingsHydrated,
    context.followersHydrated,
  ]);

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  }

  const panelExpanded = fullSrceen || context.state.peoplePanel;

  const scrollable = useRef(null);

  useEffect(() => {
    if (!scrollTarget || scrollTarget.listId !== listId || !array) return;
    if (paginate && quantity && pageSize == null) return;

    const index = array.findIndex((item) => {
      const avatar = item?.avatar;
      if (scrollTarget.type) return avatar?.design?.type === scrollTarget.type;
      if (scrollTarget.profile) {
        const profile = avatar?.design?.profile;
        return profile
          && profile[0] === scrollTarget.profile[0]
          && profile[1] === scrollTarget.profile[1];
      }
      return false;
    });

    if (index === -1) {
      onScrollTargetHandled();
      return;
    }

    const targetPage = paginate && pageSize ? Math.floor(index / pageSize) : 0;
    if (targetPage !== page) {
      setPage(targetPage);
      return;
    }

    const selector = scrollTarget.type
      ? `[data-design-type="${scrollTarget.type}"]`
      : `[data-design-profile="${scrollTarget.profile[0]}/${scrollTarget.profile[1]}"]`;

    const scrollToMatch = () => {
      const target = scrollable.current?.querySelector(selector);
      if (target && scrollable.current) {
        scrollToTop(scrollable.current.offsetTop + target.offsetTop - 120);
        onScrollTargetHandled();
        return true;
      }
      return false;
    };

    if (scrollToMatch()) return;

    let attempts = 0;
    const retry = () => {
      if (scrollToMatch() || ++attempts >= 15) {
        if (attempts >= 15) onScrollTargetHandled();
        return;
      }
      requestAnimationFrame(retry);
    };
    requestAnimationFrame(retry);
  }, [scrollTarget, page, pageSize, listId, array, arr, paginate, quantity, scrollToTop, onScrollTargetHandled]);


  return (
    <>
      {/* <div className='_fv'> */}

      {(!arr || arr.length === 0) && (loading || !arr) && <Preloader0
        className='x_choose_preloader0'
        height='12em'
        width='100%'
      >
        <Preloader width={48} height={48} />
        {$ui('loading')}
      </Preloader0>}



      {
        !loading &&
        arr && arr.length === 0
        && Boolean(emptyMessage)
        && context.state.peoplePanel
        && <div className="x_choose x_choose--empty">
          <div className="x_choose_empty">
            <div className="x_choose_empty_message">
              <Txt>{emptyMessage}</Txt>
              {/* {emptyMessage} */}
            </div>
          </div>
        </div>}


      {arr && Boolean(arr.length) && <>
        {Boolean(paginate)
          && array
          && pageSize < quantity
          && page > 0
          && (
            <div className="x_choose_pagsmall0" onClick={() => page > 0 && handlePageChange(page - 1)}>
              <div className="x_choose_page_nextprev">
                <div className="x_choose_page_np_icon">
                  <div className="t_icon">keyboard_double_arrow_up</div>
                </div>
              </div>
            </div>
          )}

        <div
          ref={scrollable}
          className={`${Boolean(customGridClass) ? customGridClass : `x_choose ${panelExpanded ? `x_choose--v ${listId ? `x_choose--${listId}` : ''}` : ''} `} `}
        >
          {arr
            .filter(one => !(one.user && exclude.includes(one.user.token)))
            .map((one = { avatar: {}, user: {} }, ind) => {
              const listIndex = (paginate && sliceSize ? page * sliceSize : 0) + ind + 1;
              const personaId = one?.user?.token || one?.avatar?.token || 'unknown';
              return (
                <Appearer
                  key={`list_${listId}_persona_${personaId}_${listIndex}`}
                  order={ind}
                  lazy
                  className={showIndex ? 'x_appearer--indexed' : ''}
                >
                  {showIndex && <div className="x_choose_card_index">{listIndex}</div>}
                  {mode === 'hd' ? <Persona
                    mode={mode}
                    customHandler={chosen.includes(one?.user?.token) && customHandlerChosen
                      ? customHandlerChosen
                      : customHandler}
                    listId={listId}
                    actions={actions}
                    panelExpanded={panelExpanded}
                    avatar={one.avatar}
                    user={one.user}
                    followings={one.followings}
                    followers={one.followers}
                    isMe={one.avatar?.isMe}
                    fullList={fullList}
                    refetch={refetch}
                    addClassName={`${panelExpanded ? 'mypeople' : 'people'} ${chosen.includes(one?.user?.token) ? 'chosen' : ''}`}
                    celeb={celeb}
                  /> : <PersonaYoni
                    customHandler={chosen.includes(one?.user?.token) && customHandlerChosen
                      ? customHandlerChosen
                      : customHandler}
                    listId={listId}
                    actions={actions}
                    panelExpanded={panelExpanded}
                    avatar={one.avatar}
                    user={one.user}
                    followings={one.followings}
                    followers={one.followers}
                    isMe={one.avatar?.isMe}
                    fullList={fullList}
                    refetch={refetch}
                    addClassName={`${panelExpanded ? 'mypeople' : 'people'} ${chosen.includes(one?.user?.token) ? 'chosen' : ''}`}
                    celeb={celeb}
                    mode={mode}
                  />}
                </Appearer>
              )
            })}

          {createNew}
        </div>

        {loading && Boolean(arr?.length) && (
          <div className="x_choose_pagsmall0" style={{ minHeight: '3em' }}>
            <Preloader width={22} height={22} />
          </div>
        )}

        {Boolean(paginate)
          && array
          && pageSize < quantity
          && page < Math.ceil(quantity / pageSize) - 1
          && (
            <div className="x_choose_pagsmall0" onClick={() => page < Math.ceil(quantity / pageSize) - 1 && handlePageChange(page + 1)}>
              <div className="x_choose_page_nextprev">
                <div className="x_choose_page_np_icon">
                  <div className="t_icon">keyboard_double_arrow_down</div>
                </div>
              </div>
            </div>
          )}
      </>}

      {Boolean(paginate)
        && array
        && pageSize < quantity
        && <>
          <Pagination
            page={page}
            pageSize={pageSize}
            total={quantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />

        </>}

      {/* </div> */}

    </>
  )
}





const Pagination = ({ page, pageSize, total, onPageChange, onPageSizeChange }) => {
  return (
    <div className="x_choose_pagination0">
      {Boolean(pageSize) && Array.from({ length: Math.ceil(total / pageSize) }).map((_, index) => (
        <div key={`pagination_${index}`} className={`x_choose_page ${page === index ? 'active' : ''}`} onClick={() => onPageChange(index)}>
          <div className="x_choose_page_num">{index + 1}</div>
        </div>
      ))}
    </div>
  )
}